module.exports = __webpack_public_path__ + "static/media/toggle-on.1dcd5ff9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/toggle-on.svg
// module id = 3671
// module chunks = 7